import { Modal as ModalModule, Utils } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { BillingPlans, Util } = Utils;

const UserLimitReachedModal = ({ modalId, data }) => {
	const { isEnterpriseAccount } = data;

	const isUserInCoreOfficeEssentialPlan =
		BillingPlans.isUserInCoreOfficeEssentialPlan();
	const isUserInEcommercePlan = BillingPlans.isUserInEcommercePlan();
	const contactNumber = Util.getFraudNumber();

	const closeButton = {
		type: ModalButtonActionType.Ok,
		text: 'Close',
		dataqa: 'user-limit-reached-close-button',
	};
	let errorMessage =
		'You currently have the maximum number of active users allowed by your current plan.';

	if (isUserInCoreOfficeEssentialPlan) {
		errorMessage = (
			<>
				You've reached the maximum number of active users for your plan.{' '}
				<a href="/changeplan">Upgrade your plan</a> to add new users.
			</>
		);
	} else if (isUserInEcommercePlan) {
		errorMessage =
			"You've reached the maximum number of active users for your plan.";
	}

	return (
		<Modal
			modalId={modalId}
			header="User Limit Reached"
			className="account-users user-limit-reached-modal"
			primaryButton={closeButton}
		>
			<div className="p-grid">
				<p className="p-col-12">{errorMessage}</p>
				{!isUserInCoreOfficeEssentialPlan && !isUserInEcommercePlan && (
					<p className="p-col-12">
						To add more users, please upgrade your plan by calling Customer
						Service at {isEnterpriseAccount ? '877-782-6785' : contactNumber}{' '}
						Monday-Friday 8 am - 8 pm Central Time.
					</p>
				)}
			</div>
		</Modal>
	);
};

export default UserLimitReachedModal;
